import { useQuery } from '@tanstack/react-query'

import cacheKeys from '../../../../services/cacheKeys'
import { subAdmins } from '../index'

const useSubAdmin = (currentPage: number, limit: number, search?: string) => {
  return useQuery({
    queryKey: [cacheKeys.SUB_ADMINS, limit, currentPage, search],
    queryFn: subAdmins,
    enabled: !!currentPage && !!limit,
  })
}

export default useSubAdmin
